module.exports = __webpack_public_path__ + "static/media/046-customer-service.a56638fb.svg";